module.exports = __webpack_public_path__ + "components/team-member/static/twitter-30c5dd336be1f2bf709803a920ec66ce.svg";